module.exports = __webpack_public_path__ + "3918aef9e8c9774135aa905115ef85ac.MP3";